export const convertDollarToCents = (dollarValue: string): string => {
    // Parse the dollar value string to a float
    const dollarAmount = parseFloat(dollarValue);
    // Convert to cents and round to avoid floating-point issues
    const cents = Math.round(dollarAmount * 100);
    // Convert the result to a string
    return cents.toString();
}



export const convertCentsToDollars = (centsValue: string): string => {
    // Parse the cents value string to an integer
    const cents = parseInt(centsValue, 10);
    // Convert to dollars
    const dollarAmount = cents / 100;
    // Format to two decimal places and convert to string
    return dollarAmount.toFixed(2);
}